import { authHeader } from '@/helpers';
import { handleResponse } from './base.service';

function logout() {
  localStorage.removeItem('user');
}

function getUser() {
  const requestOptions = {
    method: 'Get',
    headers: authHeader()
  };

  return fetch(`/api/Auth`, requestOptions)
    .then(handleResponse)
    .then(response => {
      if (response.data) {
        localStorage.setItem('user', JSON.stringify(response.data));
      }

      return response.data;
    });
}

function getAll(search: any) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  return fetch(
    `/api/Accounts?PageSize=${search.pageRows}&PageNumber=${search.actualPage}&OrderBy=${search.orderBy}&OrderByAsc=${search.orderByAsc}&OnlyActive=${
      search.filter.onlyActive
    }${search.filter.responsibleFacultyKey ? '&FacultyId=' + search.filter.responsibleFacultyKey.id : ''}${search.filter.userName ? '&UserName=' + search.filter.userName : ''}${
      search.filter.lastName ? '&LastName=' + search.filter.lastName : ''
    }`,
    requestOptions as any
  )
    .then(handleResponse)
    .then(response => {
      if (response.headers && response.headers.find((header: any) => header.key === 'x-pagination')) {
        const pagination = JSON.parse(response.headers.find((header: any) => header.key === 'x-pagination').value);
        response.data.totalCount = pagination.TotalCount;
      }

      return response.data;
    });
}

function getSolvers(facultyId: number) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  return fetch(`/api/Accounts?FacultyId=${facultyId}&UnlimitedPageSize=true`, requestOptions as any)
    .then(handleResponse)
    .then(response => {
      return response.data;
    });
}

function getOtherSolvers(userName: string) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };
  // return fetch(`/api/Accounts?UserName=${userName}&UnlimitedPageSize=true`, requestOptions as any);
  return fetch(`/api/Accounts?UnlimitedPageSize=true`, requestOptions as any)
    .then(handleResponse)
    .then(response => {
      return response.data;
    });
}

function createUser(newUser: any) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader(),
    body: JSON.stringify(newUser)
  };

  return fetch(`/api/Accounts`, requestOptions as any).then(handleResponse);
}

function updateUser(userName: string, user: any) {
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    body: JSON.stringify(user)
  };

  return fetch(`/api/Accounts/${userName}/edit`, requestOptions as any).then(handleResponse);
}

function passwordReset(username: string) {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' }
  };

  return fetch(`/api/Accounts/resetPassword/${username}`, requestOptions).then(handleResponse);
}

function passwordNew(password: string, token: string, userKey: string) {
  const requestOptions = {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      NewPassword: password,
      Token: token,
      UserKey: userKey
    })
  };

  return fetch(`/api/Accounts/resetPassword`, requestOptions).then(handleResponse);
}

function refreshToken() {
  const user = JSON.parse(localStorage.getItem('user') || 'null');

  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      AccessToken: user.accessToken.token,
      RefreshToken: user.refreshToken
    })
  };

  return fetch(`/api/Auth/refreshtoken`, requestOptions).then(response => {
    response.text().then((text: string) => {
      const data = text && JSON.parse(text);
      if (!response.ok) {
        logout();
        location.reload();
      } else {
        localStorage.setItem('user', JSON.stringify(data));
        location.reload();
      }
    });
  });
}

function getProfile() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  return fetch(`/api/profile`, requestOptions as any)
    .then(handleResponse)
    .then(response => {
      return response.data;
    });
}

function editProfile(user: any) {
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    body: JSON.stringify(user)
  };

  return fetch(`/api/Profile/edit`, requestOptions as any).then(handleResponse);
}

export const userService = {
  getUser,
  logout,
  getAll,
  createUser,
  updateUser,
  passwordReset,
  passwordNew,
  refreshToken,
  getSolvers,
  getOtherSolvers,
  getProfile,
  editProfile
};
